import { Route } from 'react-router-dom';
import UserSessionContextWrapper from './UserSessionContextWrapper';
import IdleTracker from './idle-tracker/IdleTracker';

export default function AuthenticatedRoute({ children }) {
    return (
        <Route>
            <UserSessionContextWrapper>
                <IdleTracker />
                {children}
            </UserSessionContextWrapper>
        </Route>
    );
}
